import { JobsListData } from '@contracts'
import { ColDef } from 'ag-grid-community'
import { unknown } from 'utils/constants'
import StatusCell from 'components/table/StatusCell'
import TitleWithSubtitleCell from 'components/table/TitleWithSubtitleCell'
import { getFormattedDate, getTypeKey, transformTypesToTaskType } from 'utils'
import { ExtractElementType } from 'utils/utils.d'

type ListSingleJob = ExtractElementType<JobsListData['jobs']>
export const columnStructure: ColDef<{ data: JobsListData }>[] = [
  {
    headerName: 'Task type',
    field: getTypeKey<ListSingleJob>('type'),
    sortable: true,
    flex: 1,
    resizable: true,
    cellRenderer: ({ data }: { data: ListSingleJob }) => {
      return transformTypesToTaskType(data.type)
    },
  },
  {
    headerName: 'Retailer',
    field: getTypeKey<ListSingleJob>('retailer_name'),
    sortable: true,
    flex: 1,
    resizable: true,
  },
  {
    headerName: 'Variant ID',
    field: getTypeKey<ListSingleJob>('product_id'),
    sortable: true,
    flex: 1,
    resizable: true,
  },
  {
    headerName: 'Last updated',
    field: getTypeKey<ListSingleJob>('updated_at'),
    sortable: true,
    flex: 1,
    resizable: true,
    cellRenderer: ({ data }: { data: ListSingleJob }) => (
      <TitleWithSubtitleCell title={getFormattedDate(data.updated_at)} subTitle={unknown} />
    ),
  },
  {
    field: getTypeKey<ListSingleJob>('status'),
    sortable: true,
    flex: 1,
    resizable: true,
    cellRenderer: ({ data }: { data: ListSingleJob }) => <StatusCell status={data.status} />,
  },
]
